import { type Blob } from '@consigli/types';
import { useState, type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { AddContextDocumentCard } from './add-context-document-card';
import { AddContextPanel } from './add-context-panel';
import { useAddContextDocuments } from './use-add-context-documents';

interface AddContextDocumentsPanelProps {
  onPreview: (document: Blob) => void;
  onSelectedChange: (documents: Blob[]) => void;
  selected: Blob[];
}

/** The documents this package holds: what to fetch, and how one is drawn. */
export const AddContextDocumentsPanel: FC<AddContextDocumentsPanelProps> = ({
  onPreview,
  onSelectedChange,
  selected,
}) => {
  const { t } = useTranslation();
  const [searchText, setSearchText] = useState('');
  // Filtered on the client as the user types, so there is nothing to debounce.
  const list = useAddContextDocuments(true, searchText);

  return (
    <AddContextPanel
      emptyMessage={t('prop-chat.add-context-no-documents')}
      list={list}
      onSearchTextChange={setSearchText}
      onSelectedChange={onSelectedChange}
      renderItem={(document, isSelected, onToggle) => (
        <AddContextDocumentCard
          key={document.id}
          document={document}
          onPreview={onPreview}
          onSelectedChange={onToggle}
          selected={isSelected}
        />
      )}
      searchLabel={t('findings.search-document-names')}
      searchText={searchText}
      selected={selected}
    />
  );
};
